<div class="substation-list">
  <lib-asset-list-header
    [title]="title"
    [hideAddNew]="true"
  ></lib-asset-list-header>
  <lib-dynamic-cards [emcOptions]="emcOptions" [filter]="filter" [entityType]="entityType" #dynamicCards>
  </lib-dynamic-cards>
  <div class="row filter">
    <div class="col-7 filter-bar">
      <lib-filter-dynamic
        [entityType]="entityType"
        [substationTemplateId]="substationTemplateId"
        (sortChanged)="onSortTypeChange($event)"
        (filterWindow)="onFilterWindowChange($event)"
        (dynamicFilterWindow)="onDynamicFilterWindowChange($event)"
        (addFilterCard)="onAddFilterCard($event)"
        (clearSearch)="filter.filterParams.search = ''"
        (searchOutputFilter)="searchfilter($event)"
      ></lib-filter-dynamic>
      <span *ngIf="checklistItems.length == 0" class="no-filters">{{
        "COMMON.NO_FILLTERS_APPLIED" | translate
      }}</span>
    </div>
    <div *ngIf="permissionsService.isNetworkStructureDownloadAllowed" class="col-5 text-end download-btn-wrapper">
      <button (click)="download()">
        {{ "COMMON.DOWNLOAD" | translate }}
        <span style="margin-left: 0.4rem">
          <svg
            width="11"
            height="14"
            viewBox="0 0 11 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.0002 8.39394L5.64415 12.75L1.28809 8.39394M5.64415 12.2273V1.25"
              stroke="#17171A"
              stroke-opacity="0.6"
              stroke-width="1.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      </button>
    </div>
    <div *ngIf="checklistItems.length > 0">
      <lib-filter-checklist
        [filters]="checklistItems"
        [useApply]="true"
        (applyFilterEmitter)="applyFilter()"
        (resetFilterEmitter)="resetFilter()"
        (removeFilterEmitter)="removeFilter($event)"
      ></lib-filter-checklist>
    </div>
  </div>

  <div class="table-wrapper">
    <div class="table-container overflow-auto">
      <table>
        <thead>
          <tr>
            <th class="th-checkbox"><input type="checkbox" /></th>
            <th *ngFor="let header of tableListPage.headers">
              {{ header.name }}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of tableListPage.rows">
            <td type="checkbox"><input type="checkbox" /></td>
            <td
              *ngFor="let cell of row.data"
              [ngSwitch]="cell.valueType"
              (click)="onRowClick(row.guid)"
              (mouseenter)="showCellTooltip($event)"
              (mouseleave)="hideCellTooltip()"
            >
              <span *ngSwitchCase="'String'">{{
                cell.stringValue | hasValue
              }}</span>
              <span *ngSwitchCase="'Int'">{{ cell.intValue | hasValue }}</span>
              <span *ngSwitchCase="'Date'"
                >{{ cell.dateTimeValue | date:'dd/MM/yyyy':'{{ timeZone }}' |
                hasValue }}</span
              >
              <span *ngSwitchCase="'Bool'">{{
                cell.boolValue | hasValue
              }}</span>
              <span *ngSwitchDefault>{{ "/" }}</span>
            </td>
            <td>...</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pagination">
      <lib-asset-list-pagination
        [pageFromList]="filter.pageInfo.page"
        (pageChanged)="onPageChange($event)"
        [totalItems]="tableListPage.count!"
      ></lib-asset-list-pagination>
    </div>
  </div>

  <lib-dynamic-filter-window
    *ngIf="isDynamicFilterWindowOpened"
    (close)="closeDynamicFilterWindow()"
    [filter]="filter"
    [entityType]="entityType"
    [substationTemplateId]="substationTemplateId"
    (addFilter)="onAddFilter()"
  ></lib-dynamic-filter-window>
</div>

<router-outlet></router-outlet>
